import { useQuery } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { SubChildCategory } from "../../../categories/categories.types";
import { requestGetCategoryById } from "./getCategoryById.request";

const useGetCategoryById = (
  categoryId: string | undefined,
  options?: QueryOptions<SubChildCategory, ApiServiceError<ApiError>>
) => {
  const { data: category, ...rest } = useQuery({
    queryKey: ["category-admin", "one", categoryId],
    queryFn: async () => {
      return await requestGetCategoryById(String(categoryId));
    },
    enabled: !!categoryId,
    cacheTime: 0,
    ...options
  });

  return { category, ...rest };
};

export default useGetCategoryById;
